var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    fill: "none",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#050404",
    fillOpacity: 0.986,
    d: "M -0.5,-0.5 C 2.16667,-0.5 4.83333,-0.5 7.5,-0.5 C 9.11264,2.28614 10.946,4.9528 13,7.5 C 15.4145,4.98605 17.5812,2.31938 19.5,-0.5 C 20.8333,-0.5 22.1667,-0.5 23.5,-0.5 C 23.5,-0.166667 23.5,0.166667 23.5,0.5 C 20.0012,3.16623 17.0012,6.33289 14.5,10 C 17.399,14.3221 20.399,18.4887 23.5,22.5 C 23.5,23.1667 23.5,23.8333 23.5,24.5 C 20.8333,24.5 18.1667,24.5 15.5,24.5 C 13.6778,21.5279 11.8445,18.5279 10,15.5 C 6.91157,18.0814 4.41157,21.0814 2.5,24.5 C 1.5,24.5 0.5,24.5 -0.5,24.5 C -0.5,23.8333 -0.5,23.1667 -0.5,22.5 C 2.36834,19.3121 5.36834,16.1454 8.5,13 C 5.35958,9.18821 2.35958,5.35488 -0.5,1.5 C -0.5,0.833333 -0.5,0.166667 -0.5,-0.5 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.5,2.5 C 4.18944,1.22641 5.02278,1.22641 6,2.5 C 10.5,9 15,15.5 19.5,22 C 18.5509,22.6172 17.7175,22.4506 17,21.5 C 12.9693,14.7482 8.46931,8.41488 3.5,2.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/TwitterLogo.e26d2bc006561244c3b137102b399c49.svg";
export { ForwardRef as ReactComponent };